const ROLES = {
  superAdmin: 'tivi-root-admin',
  eventAdmin: 'tivi-event-admin',
  pollWorker: 'tivi-pollworker',
  auditor: 'tivi-auditor',
  eventAdminDeveloper: 'tivi-developer',
  voterAdminDeveloper: 'voter-admin-developer',
  contactInfo: 'tivi-contactinfo',
  vbmAdmin: 'neuvote-vbm-admin',
}

export const DefaultAdminRolesRequiredPerAction = {
  strikeOffEnabled: [ROLES.pollWorker, ROLES.contactInfo, ROLES.superAdmin, ROLES.vbmAdmin, ROLES.auditor],
  adminUsers: {
    add: [ROLES.superAdmin],
    delete: [ROLES.superAdmin],
    authActions: [ROLES.superAdmin, ROLES.contactInfo],
  },
}
